// import React, { useEffect, useState } from "react";
// import { useParams, useHistory } from "react-router-dom";
// import {
//   Row, Col, Card, Button, Typography, Descriptions, Tag, 
//   notification, Spin, Avatar, Divider
// } from "antd";
// import axios from "axios";
// import { baseUrl } from "../../config";
// import {
//   ArrowLeftOutlined, EditOutlined, UserOutlined, PhoneOutlined,
//   MailOutlined, BankOutlined, EnvironmentOutlined, CalendarOutlined
// } from "@ant-design/icons";
// import moment from 'moment';
// import { hasPermission } from '../../components/permissions';

// const { Title, Text } = Typography;

// function BeneficiariesView() {
//   const { id } = useParams();
//   const history = useHistory();
//   const [beneficiary, setBeneficiary] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     fetchBeneficiaryDetails();
//   }, [id]);

//   const fetchBeneficiaryDetails = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${baseUrl}/beneficiaries/read/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         },
//       });
      
//       if (response.status === 200) {
//         setBeneficiary(response.data.result);
//       }
//     } catch (error) {
//       notification.error({
//         message: 'Error',
//         description: 'Failed to fetch beneficiary details',
//         placement: 'topRight'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getTypeColor = (type) => {
//     const colors = {
//       'Student': 'blue',
//       'Staff': 'green',
//       'Vendor': 'orange',
//       'Gurukul': 'purple',
//       'Other': 'default'
//     };
//     return colors[type] || 'default';
//   };

//   if (loading) {
//     return (
//       <div style={{ textAlign: 'center', padding: '50px' }}>
//         <Spin size="large" />
//       </div>
//     );
//   }

//   if (!beneficiary) {
//     return (
//       <div style={{ textAlign: 'center', padding: '50px' }}>
//         <Text>Beneficiary not found</Text>
//       </div>
//     );
//   }

//   return (
//     <div style={{ padding: '24px' }}>
//       <Row gutter={[24, 24]}>
//         <Col span={24}>
//           <Card>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
//                 <Button 
//                   icon={<ArrowLeftOutlined />} 
//                   onClick={() => history.goBack()}
//                   size="large"
//                 />
//                 <Avatar size={64} icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
//                 <div>
//                   <Title level={2} style={{ margin: 0 }}>{beneficiary.name}</Title>
//                   <Tag color={getTypeColor(beneficiary.type)} style={{ marginTop: '8px' }}>
//                     {beneficiary.type}
//                   </Tag>
//                 </div>
//               </div>
//               {hasPermission('/beneficiaries', 'editPermission') && (
//                 <Button 
//                   type="primary" 
//                   icon={<EditOutlined />}
//                   onClick={() => history.push(`/beneficiaries/update/${id}`)}
//                   size="large"
//                 >
//                   Edit Beneficiary
//                 </Button>
//               )}
//             </div>

//             <Row gutter={[24, 24]}>
//               <Col xs={24} lg={12}>
//                 <Card title="Personal Information" size="small">
//                   <Descriptions column={1} bordered size="small">
//                     <Descriptions.Item 
//                       label={<><UserOutlined /> Name</>}
//                     >
//                       {beneficiary.name}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label={<><UserOutlined /> Father's Name</>}
//                     >
//                       {beneficiary.father_name || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="Gender"
//                     >
//                       {beneficiary.gender || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label={<><CalendarOutlined /> Date of Birth</>}
//                     >
//                       {beneficiary.dob ? moment(beneficiary.dob).format('DD MMM YYYY') : '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="Status"
//                     >
//                       <Tag color={beneficiary.status === 'Active' ? 'success' : 'warning'}>
//                         {beneficiary.status}
//                       </Tag>
//                     </Descriptions.Item>
//                   </Descriptions>
//                 </Card>
//               </Col>

//               <Col xs={24} lg={12}>
//                 <Card title="Contact Information" size="small">
//                   <Descriptions column={1} bordered size="small">
//                     <Descriptions.Item 
//                       label={<><PhoneOutlined /> Phone</>}
//                     >
//                       {beneficiary.phone || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label={<><MailOutlined /> Email</>}
//                     >
//                       {beneficiary.email || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label={<><EnvironmentOutlined /> Address</>}
//                     >
//                       {beneficiary.address || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="City"
//                     >
//                       {beneficiary.city || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="State"
//                     >
//                       {beneficiary.state || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="Pincode"
//                     >
//                       {beneficiary.pincode || '-'}
//                     </Descriptions.Item>
//                   </Descriptions>
//                 </Card>
//               </Col>

//               <Col xs={24} lg={12}>
//                 <Card title="Bank Details" size="small">
//                   <Descriptions column={1} bordered size="small">
//                     <Descriptions.Item 
//                       label={<><BankOutlined /> Bank Name</>}
//                     >
//                       {beneficiary.bank_name || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="Account Number"
//                     >
//                       {beneficiary.bank_account_no || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="IFSC Code"
//                     >
//                       {beneficiary.ifsc_code || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="Branch"
//                     >
//                       {beneficiary.branch_name || '-'}
//                     </Descriptions.Item>
//                   </Descriptions>
//                 </Card>
//               </Col>

//               <Col xs={24} lg={12}>
//                 <Card title="System Information" size="small">
//                   <Descriptions column={1} bordered size="small">
//                     <Descriptions.Item 
//                       label="Aadhar Number"
//                     >
//                       {beneficiary.aadhar_no || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="PAN Number"
//                     >
//                       {beneficiary.pan_no || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="GST Number"
//                     >
//                       {beneficiary.gst_no || '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="Registration Date"
//                     >
//                       {beneficiary.registration_date ? moment(beneficiary.registration_date).format('DD MMM YYYY') : '-'}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="Created On"
//                     >
//                       {moment(beneficiary.created_at).format('DD MMM YYYY, HH:mm')}
//                     </Descriptions.Item>
//                     <Descriptions.Item 
//                       label="Last Updated"
//                     >
//                       {moment(beneficiary.updated_at).format('DD MMM YYYY, HH:mm')}
//                     </Descriptions.Item>
//                   </Descriptions>
//                 </Card>
//               </Col>
//             </Row>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );
// }

// export default BeneficiariesView;



import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Row, Col, Card, Button, Typography, Descriptions, Tag,
  notification, Spin, Avatar, Divider, Tooltip
} from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import {
  ArrowLeftOutlined, EditOutlined, UserOutlined, PhoneOutlined,
  MailOutlined, BankOutlined, EnvironmentOutlined, CalendarOutlined,
  IdcardOutlined, FileProtectOutlined, EyeOutlined, FilePdfOutlined
} from "@ant-design/icons";
import moment from 'moment';
import { hasPermission } from '../../components/permissions';

const { Title, Text } = Typography;

function BeneficiariesView({ beneficiaryId, onEdit, isModal = false }) {
  const { id } = useParams();
  const history = useHistory();
  const [beneficiary, setBeneficiary] = useState(null);
  const [loading, setLoading] = useState(false);

  // Use beneficiaryId prop if provided (modal mode), otherwise use params
  const currentBeneficiaryId = beneficiaryId || id;

  useEffect(() => {
    if (currentBeneficiaryId) {
      fetchBeneficiaryDetails();
    }
  }, [currentBeneficiaryId]);

  const fetchBeneficiaryDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/beneficiaries/read/${currentBeneficiaryId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      
      if (response.status === 200) {
        setBeneficiary(response.data.result);
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch beneficiary details',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  const getTypeColor = (type) => {
    const colors = {
      'Student': 'blue',
      'Staff': 'green',
      'Vendor': 'orange',
      'Gurukul': 'purple',
      'Other': 'default'
    };
    return colors[type] || 'default';
  };

  const handleEdit = () => {
    if (isModal && onEdit) {
      onEdit(currentBeneficiaryId);
    } else {
      // For standalone page, navigate to edit route
      history.push(`/beneficiaries/update/${currentBeneficiaryId}`);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!beneficiary) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Text>Beneficiary not found</Text>
      </div>
    );
  }

  return (
    <div style={{ padding: isModal ? '0' : '24px' }}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              marginBottom: '20px' 
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                {!isModal && (
                  <Button 
                    icon={<ArrowLeftOutlined />} 
                    onClick={() => history.goBack()}
                    size="large"
                  />
                )}
                {beneficiary.photo_url
                  ? <Avatar size={64} src={beneficiary.photo_url} style={{ border: '2px solid #7a0000' }} />
                  : <Avatar size={64} icon={<UserOutlined />} style={{ backgroundColor: '#7a0000' }} />
                }
                <div>
                  <Title level={3} style={{ margin: 0 }}>{beneficiary.name}</Title>
                  <Tag color={getTypeColor(beneficiary.type)} style={{ marginTop: '4px' }}>
                    {beneficiary.type}
                  </Tag>
                </div>
              </div>
              {hasPermission('/beneficiaries', 'editPermission') && (
                <Button
                  icon={<EditOutlined />}
                  onClick={handleEdit}
                  size="large"
                  style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                >
                  Edit Beneficiary
                </Button>
              )}
            </div>

            <Row gutter={[16, 16]}>
              <Col xs={24} lg={12}>
                <Card title="Personal Information" size="small">
                  <Descriptions column={1} bordered size="small">
                    <Descriptions.Item 
                      label={<><UserOutlined style={{ marginRight: '4px' }} /> Name</>}
                    >
                      {beneficiary.name}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label={<><UserOutlined style={{ marginRight: '4px' }} /> Father's Name</>}
                    >
                      {beneficiary.father_name || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Gender — बालक/बालिका">
                      {beneficiary.gender
                        ? <Tag color={beneficiary.gender === 'Male' ? 'blue' : 'pink'}>
                            {beneficiary.gender === 'Male' ? 'बालक (Male)' : 'बालिका (Female)'}
                          </Tag>
                        : '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="पारिवारिक स्थिति">
                      {beneficiary.family_status || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<><CalendarOutlined style={{ marginRight: '4px' }} /> Date of Birth</>}
                    >
                      {beneficiary.dob ? moment(beneficiary.dob).format('DD MMM YYYY') : '-'}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label="Status"
                    >
                      <Tag color={beneficiary.status === 'Active' ? 'success' : 'warning'}>
                        {beneficiary.status}
                      </Tag>
                    </Descriptions.Item>
                  </Descriptions>
                </Card>
              </Col>

              <Col xs={24} lg={12}>
                <Card title="Contact Information" size="small">
                  <Descriptions column={1} bordered size="small">
                    <Descriptions.Item 
                      label={<><PhoneOutlined style={{ marginRight: '4px' }} /> Phone</>}
                    >
                      {beneficiary.phone || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label={<><MailOutlined style={{ marginRight: '4px' }} /> Email</>}
                    >
                      {beneficiary.email || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label={<><EnvironmentOutlined style={{ marginRight: '4px' }} /> Address</>}
                    >
                      {beneficiary.address || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label="City"
                    >
                      {beneficiary.city || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label="State"
                    >
                      {beneficiary.state || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label="Pincode"
                    >
                      {beneficiary.pincode || '-'}
                    </Descriptions.Item>
                  </Descriptions>
                </Card>
              </Col>

              <Col xs={24} lg={12}>
                <Card title="Bank Details" size="small">
                  <Descriptions column={1} bordered size="small">
                    <Descriptions.Item 
                      label={<><BankOutlined style={{ marginRight: '4px' }} /> Bank Name</>}
                    >
                      {beneficiary.bank_name || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label="Account Number"
                    >
                      {beneficiary.bank_account_no || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label="IFSC Code"
                    >
                      {beneficiary.ifsc_code || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item 
                      label="Branch"
                    >
                      {beneficiary.branch_name || '-'}
                    </Descriptions.Item>
                  </Descriptions>
                </Card>
              </Col>

              <Col xs={24} lg={12}>
                <Card title="Identity & System Info" size="small">
                  <Descriptions column={1} bordered size="small">
                    <Descriptions.Item label="Aadhar Number">{beneficiary.aadhar_no || '-'}</Descriptions.Item>
                    <Descriptions.Item label="PAN Number">{beneficiary.pan_no || '-'}</Descriptions.Item>
                    <Descriptions.Item label="GST Number">{beneficiary.gst_no || '-'}</Descriptions.Item>
                    <Descriptions.Item label="Registration Date">
                      {beneficiary.registration_date ? moment(beneficiary.registration_date).format('DD MMM YYYY') : '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Created On">
                      {moment(beneficiary.created_at).format('DD MMM YYYY, HH:mm')}
                    </Descriptions.Item>
                    <Descriptions.Item label="Last Updated">
                      {moment(beneficiary.updated_at).format('DD MMM YYYY, HH:mm')}
                    </Descriptions.Item>
                  </Descriptions>
                </Card>
              </Col>

              {/* Documents Section */}
              {(() => {
                const docs = [
                  { label: 'Profile Photo',         key: 'photo_url',      icon: <UserOutlined />,        isImage: true },
                  { label: 'Aadhar Card',            key: 'aadhar_doc_url', icon: <IdcardOutlined />,      isImage: false },
                  { label: 'PAN Card',               key: 'pan_doc_url',    icon: <IdcardOutlined />,      isImage: false },
                  { label: 'Bank Passbook / Cheque', key: 'bank_doc_url',   icon: <BankOutlined />,        isImage: false },
                  { label: 'GST Certificate',        key: 'gst_doc_url',    icon: <FileProtectOutlined />, isImage: false },
                ];
                const hasDocs = docs.some(d => beneficiary[d.key]);
                return (
                  <Col span={24}>
                    <Card
                      title={<span><IdcardOutlined style={{ marginRight: 8 }} />Documents</span>}
                      size="small"
                    >
                      {hasDocs ? (
                        <Row gutter={[12, 12]}>
                          {docs.map(doc => {
                            const url = beneficiary[doc.key];
                            if (!url) return null;
                            const isPdf = url.toLowerCase().endsWith('.pdf');
                            return (
                              <Col key={doc.key} xs={12} sm={8} md={6} lg={4}>
                                <div style={{
                                  border: '1px solid #e8e8e8',
                                  borderRadius: 8,
                                  padding: '12px 8px',
                                  textAlign: 'center',
                                  background: '#fafafa'
                                }}>
                                  {doc.isImage && !isPdf ? (
                                    <Avatar src={url} size={56} style={{ marginBottom: 8, display: 'block', margin: '0 auto 8px' }} />
                                  ) : (
                                    <div style={{ fontSize: 36, marginBottom: 8, color: isPdf ? '#ff4d4f' : '#1890ff' }}>
                                      {isPdf ? <FilePdfOutlined /> : doc.icon}
                                    </div>
                                  )}
                                  <div style={{ fontSize: 11, color: '#666', marginBottom: 8, fontWeight: 600 }}>{doc.label}</div>
                                  <Tooltip title="View / Download">
                                    <Button
                                      size="small"
                                      icon={<EyeOutlined />}
                                      onClick={() => window.open(url, '_blank')}
                                      style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                                    >
                                      View
                                    </Button>
                                  </Tooltip>
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                      ) : (
                        <div style={{ textAlign: 'center', color: '#aaa', padding: '20px 0' }}>
                          No documents uploaded yet.
                        </div>
                      )}
                    </Card>
                  </Col>
                );
              })()}
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default BeneficiariesView;